import './style.css';
import {ThemeContext,themes} from "../../contexts/ThemeContext";
import DayNightIcon from "../../assets/svgIcon/DayNightIcon";
import MainIcon from "../../assets/svgIcon/MainIcon"
import { useState } from 'react';

export default function HomeSection(){
    const [darkMode, setDarkMode] = useState(true);
    return(
        <section id="Home">
            <div className="page center">
                <ThemeContext.Consumer>
                    {({ changeTheme }) => (
                        <label htmlFor="mode" className='flex mode click-hover' >
                            <input type="checkbox" id='mode' onChange={()=>{
                            setDarkMode(!darkMode);
                            changeTheme(darkMode ? themes.light : themes.dark);
                            }} />
                            <DayNightIcon/>
                        </label>
                    )}
                </ThemeContext.Consumer>
                <div className="profile">
                    <div className="profile-left">
                        <h1 className="title"><span>Hi! I'm a</span><br/> Software Engineer (Golang)</h1>
                        <span className="h-line"></span>
                        
                        <p className="description">I'm "<span>Uttam Nath</span>", Software Engineer with <span>3+ years of experience in Golang</span>, building <span>scalable microservices</span>, <span>REST APIs</span>, and <span>distributed systems</span>.
Skilled in <span>Docker</span>, <span>Kubernetes</span>, <span>Kafka</span>, and <span>Redis</span>, with a strong focus on <span>performance optimization</span> and clean architecture.
Experienced in developing fault-tolerant, production-ready applications and improving system efficiency.
Driven by continuous learning and solving real-world engineering challenges.</p>
                        <a target='_blank' rel="noopener noreferrer" href='https://drive.google.com/file/d/1CcIpHSD7ogqx8qx75ojOMXkKmjNEP0BJ/view' className='btn-cv'>Get My Resume</a>
                    </div>
                </div>
            </div>
        </section>
    );
}